import React, { useEffect, useState } from 'react';

const pad = (n) => String(n).padStart(2, '0');

export const Timecode = () => {
  const [frames, setFrames] = useState(12 * 60 * 24 + 48 * 24);
  useEffect(() => {
    const t = setInterval(() => setFrames((f) => f + 1), 1000 / 24);
    return () => clearInterval(t);
  }, []);
  const s = Math.floor(frames / 24);
  return (
    <span className="sh-mono tabular-nums" data-testid="hero-timecode">
      {pad(Math.floor(s / 3600))}:{pad(Math.floor(s / 60) % 60)}:{pad(s % 60)}:{pad(frames % 24)}
    </span>
  );
};
